import KDSelect from "../../components/FormComponents/KDSelect";
import CommonTopsection from "../../components/TopSection";

const RequestPayoffDemand=()=> {
  return (
    <div
      
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h4>Request Payoff Demand</h4>
          </div>
          <CommonTopsection />
        </article>
        <article className="container-fluid">
          <div className="col p-3 d-flex align-items-center justify-content-start select-loan">
            <span className="pe-5">Select Loan</span>{" "}
            <KDSelect
              valueLabelList={[
                { label: "Choose lender loan", value: "Loan 1" },
              ]}
              fieldReadOnly={true}
            />
          </div>

          <div className="loan-payoff-estimate">
            <div className="p-3">
              <div className="bg-white py-5">
                <div className="w-100 d-flex justify-content-between p-5">
                  <div>
                    <p className="pb-0 mb-0 loan-payoff-title">Borrower</p>
                    <p className="pb-0 mb-0 loan-payoff-data">John Doe</p>
                  </div>
                  <div>
                    <p className="pb-0 mb-0 loan-payoff-title">Property</p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                  <div>
                    <p className="pb-0 mb-0 loan-payoff-title">UPB</p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                  <div>
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Next Payment Due
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$1,600.00</p>
                  </div>
                  <div>
                    <p className="pb-0 mb-0 loan-payoff-title">Maturity Date</p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                </div>
              </div>
            </div>

            {/* loan payoff estimate */}
            <div className="p-3">
              <div className="bg-white p-5">
                <h4 className="p-5 loan-payoff-header">Loan Payoff Estimate</h4>
                <div className="w-100 d-flex row justify-content-between p-5">
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Borrower</p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Next Payment Due
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Interest Date</p>
                    <p className="pb-0 mb-0 loan-payoff-data">01-07-2021</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Interest Paid to Date
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$1,600.00</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Principal Balance
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$158,494</p>
                  </div>
                </div>
                <div className="w-100 d-flex row justify-content-between p-5">
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Unpaid Interest
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">
                      $2,897 / $10,203
                    </p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Accured Interest
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">
                      $2,897 / $10,203
                    </p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Unpaid Late Charges
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$404 / $1,425</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Accured Late Charges
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$416</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Unpaid Charges
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$0.00</p>
                  </div>
                </div>
                <div className="w-100 d-flex row justify-content-between p-5">
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Other Fees</p>
                    <p className="pb-0 mb-0 loan-payoff-data">$0</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Prepayment Penalty
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">$0.00</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Trust Balance</p>
                    <p className="pb-0 mb-0 loan-payoff-data">$1,465</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0">&nbsp;</p>
                    <p className="pb-0 mb-0">&nbsp;</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0">&nbsp;</p>
                    <p className="pb-0 mb-0">&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Requesting Party Information */}
            <div className="p-3">
              <div className="bg-white p-5">
                <h4 className="p-5 loan-payoff-header">
                  Requesting Party Information
                </h4>
                <div className="w-100 d-flex row justify-content-between p-5">
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Email ID</p>
                    <p className="pb-0 mb-0 loan-payoff-data">
                      johndoe12@gmail.com
                    </p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Closing agent</p>
                    <p className="pb-0 mb-0 loan-payoff-data">
                      Daniel kauffman
                    </p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">Phone Number</p>
                    <p className="pb-0 mb-0 loan-payoff-data">+1 68421 23541</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">File/Escrow#</p>
                    <p className="pb-0 mb-0 loan-payoff-data">-</p>
                  </div>
                  <div className="col-2">
                    <p className="pb-0 mb-0 loan-payoff-title">
                      Ext. CLosing Date
                    </p>
                    <p className="pb-0 mb-0 loan-payoff-data">10-08-2022</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
}
export default RequestPayoffDemand